"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import { AudioOutputProvider } from "@/lib/audio-output";

export function Providers({ children }: { children: React.ReactNode }) {
  const [client] = useState(() => new QueryClient());
  return (
    <QueryClientProvider client={client}>
      {/* Outside LanguageProvider on purpose: that provider remounts its
          subtree on every language switch (see lib/i18n.tsx), which would
          otherwise tear down and recreate this one's MutationObserver for
          no reason. */}
      <AudioOutputProvider>
        {/* Inside the query client on purpose: switching language remounts
            the tree below it, and the cache must survive that or the whole
            app would refetch. */}
        <LanguageProvider>
          {children}
          <Toaster />
        </LanguageProvider>
      </AudioOutputProvider>
    </QueryClientProvider>
  );
}
